/** True for iPhone/iPad/iPod, including iPadOS desktop user-agent mode. */
export function isAppleMobileRuntime(): boolean {
  if (typeof navigator === 'undefined') {
    return false
  }

  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}
